export default __webpack_public_path__ + "static/media/discord.42964702.svg";